import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {colors} from '../../../style/constants.js';

const useStyles = makeStyles(() => ({
  button: {
    width: 20,
    height: 40,
    background: 'none',
    padding: 0,
    '& svg': {
      width: '100%',
      height: '100%'
    }
  }
}));

const ArrowLeftButton = (props) => {
  const classes = useStyles();
  return (
    <button aria-label="ArrowLeftButton" onClick={props.onClick} className={classes.button + " arrow-left"}>
      <svg xmlns="http://www.w3.org/2000/svg" className="clickable" viewBox="0 0 21.87 38.74">
        <g>
          <polyline points="19.37 36.24 2.5 19.37 19.37 2.5" fill="none" stroke={colors.TURQUOISE} strokeLinecap="round" strokeLinejoin="round" strokeWidth="5px"/>
        </g>
      </svg>
    </button>
  )
};

const ArrowRightButton = (props) => {
  const classes = useStyles();
  return (
    <button aria-label="ArrowRightButton" onClick={props.onClick} className={classes.button + " arrow-right"}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.87 38.74">
        <g>
          <polyline points="2.5 2.5 19.37 19.37 2.5 36.24" fill="none" stroke={colors.TURQUOISE} strokeLinecap="round" strokeLinejoin="round" strokeWidth="5px"/>
        </g>
      </svg>
    </button>
  )
};

export {ArrowLeftButton, ArrowRightButton};